module.exports = __webpack_public_path__ + "static/media/18ECA17.e5de0497.jpg";